import {
  IHttpInterceptor,
  IHttpResponse,
  ILocationService,
  IWindowService,
  IQService,
} from "angular";

export const vsName = "httpUnauthenticatedInterceptorService";

httpUnauthenticatedInterceptorRegistrationFunction.$inject = [vsName];
export function httpUnauthenticatedInterceptorRegistrationFunction(
  httpUnauthenticatedInterceptor: HttpUnauthenticatedInterceptorService
): IHttpInterceptor {
  return {
    responseError: (error: IHttpResponse<any>) =>
      httpUnauthenticatedInterceptor.responseError(error),
  };
}

export class HttpUnauthenticatedInterceptorService {
  static $inject = ["$window", "$location", "$q", "userProfile"];

  openLoginInNewWindow: boolean = false;

  constructor(
    private readonly $window: IWindowService,
    private readonly $location: ILocationService,
    private readonly $q: IQService,
    userProfile: any
  ) {
    this.openLoginInNewWindow = userProfile.isAuthenticated();
  }

  responseError(httpResponse: IHttpResponse<any>) {
    if (!this.isAuthenticationError(httpResponse)) {
      return httpResponse;
    }

    this.openLoginInNewWindow
      ? this.$window.open("/login?closeAfterLogin=true", "slottrakLogin")
      : this.$location.path("/login");

    return this.$q.reject(httpResponse);
  }

  private isAuthenticationError(rejection: IHttpResponse<any> | undefined) {
    return rejection?.status === 401;
  }
}
